<template>
    <v-flex hidden-sm-and-up >
        <v-system-bar>    
            <v-layout rop wrap>                
                <v-flex xs12 >
                    {{$store.state.usuario.resource}} - {{$store.state.usuario.name}}              
                </v-flex>            
            </v-layout>        
        </v-system-bar>
    </v-flex>
</template>
<script>
export default {
    name: 'SystemBar',    
}
</script>
<style scoped>

</style>